export default function Message({ justify, message }) {
    const msgStyle =
      justify === 'end' ? `bg-[#4E426D] text-white` : `text-gray-700`;
    return (
      <li className={`flex my-2 justify-${justify}`}>
        <div
          className={`relative max-w-xl px-4 py-2  rounded shadow ${msgStyle}`}
        >
          <span className="block">{message}</span>
        </div>
      </li>
    );
  }
  